import React from 'react';
import classNames from 'classnames';

import { REFERRAL_TRACKING } from '~referral/utils/trackingEvents';
import { Tappable } from '@common/ui/general';
import analytics from '~profile_stats/analytics';
import CircularLoader from '@common/ui/general/CircularLoader';
import Download from '@common/images/svg/download-1.svg';
import LinkedIn from '@common/images/svg/linkedin-3.svg';
import coin from '@common/images/svg/coin.svg';
import twitter from '@common/images/svg/twitter-x.svg';
import whatsApp from '@common/images/svg/whatsApp.svg';


const Footer = ({
  isReady,
  handleRequest,
  sharableLinks,
  handleWhatsAppShareRequest,
  handleTwitterShareRequest,
}) => {
  const handleDownloadImage = () => {
    analytics.click(
      REFERRAL_TRACKING.clickDownloadImageButton,
      'Shareable nudge',
    );
  };

  return (
    <div className="profile-stats-modal__footer">
      <>
        {!isReady ? (
          <CircularLoader />
        ) : (
          <div
            key="twitter"
            name="twitter"
            onClick={handleTwitterShareRequest}
            role="presentation"
            className="profile-stats-modal__share-btns"
          >
            <img
              src={twitter}
              alt="twitter"
              className="profile-stats-modal__share-btns"
            />
          </div>
        )}
      </>
      <>
        {!isReady ? (
          <CircularLoader />
        ) : (
          <div
            key="whatsapp"
            name="whatsapp"
            onClick={handleWhatsAppShareRequest}
            role="presentation"
            className="profile-stats-modal__share-btns"
          >
            <img
              src={whatsApp}
              alt="whatsapp"
              className="profile-stats-modal__share-btns"
            />
          </div>
        )}
      </>
      {!isReady ? (
        <CircularLoader />
      ) : (
        <>
          <Tappable
            arget="_blank"
            rel="noopener noreferrer"
            href={sharableLinks?.directLink}
            onClick={handleDownloadImage}
            className={classNames(
              'no-highlight row align-c',
              'profile-stats-modal__share-btns',
              { 'profile-stats-modal__download-btn--disabled': false },
            )}
          >
            <img
              src={Download}
              className="m-r-10 profile-stats-modal__share-btns"
              alt="download"
            />
          </Tappable>
        </>
      )}

      <Tappable
        className={classNames(
          'flex-fill row',
          'profile-stats-modal__share-btn',
        )}
        key="linkedin"
        name="linkedin"
        data-link=""
        onClick={handleRequest}
      >
        <div
          className="profile-stats-modal__li-btn-container align-c"
        >
          <div className="profile-stats-modal__li align-c">
            <img
              src={LinkedIn}
              alt="linkedin"
              className="m-r-5
                      profile-stats-modal__img-size"
              name="linkedin"
            />
            Share on LinkedIn
          </div>
          <div className="profile-stats-modal__li-sub-text align-c">
            <img
              src={coin}
              alt="coin"
              className="m-r-5 profile-stats-modal__coin-size"
            />
            + 200 Coins
          </div>
        </div>
      </Tappable>
    </div>
  );
};

export default Footer;
